module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-01@3x-3719cb1b2602547f1e7b29ef516f33b6.png";